module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "download-coin-wrap"
  }, [_c('header', [_c('img', {
    attrs: {
      "src": require("../assets/download-coin-logo.png"),
      "alt": "All Sepakbola"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("All Sepakbola")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.$t('bestApp')))])]), _vm._v(" "), (!_vm.isAndroid) ? _c('section', [_c('div', {
    staticClass: "invite-code"
  }, [_c('input', {
    staticClass: "invite-code-input",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.inviteCode
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "copy",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copy()
      }
    }
  }, [_c('i', {
    staticClass: "icon-copy"
  }), _vm._v("  " + _vm._s(_vm.$t('copy')))])]), _vm._v(" "), _c('p', [_vm._v("* " + _vm._s(_vm.$t('downloadForCoin')))]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copyAndDownload()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('download')) + " "), _c('i', {
    staticClass: "icon-download"
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cfb9bae","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppDownloadCoin.vue
// module id = 863
// module chunks = 12